import { HelmetProvider, Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const PageMeta = ({
	title,
	description,
}: {
	title: string;
	description: string;
}) => {
	const { i18n } = useTranslation();

	// Force update when language changes
	useEffect(() => {
		document.title = title;
	}, [title, i18n.language]);

	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
		</Helmet>
	);
};

export const AppWrapper = ({ children }: { children: React.ReactNode }) => (
	<HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
